export const HOME = {
  name: 'Rocha Brava Village Resort',
  shortName: 'Rocha Brava',
  tagline: 'Village Resort',
  address: 'Urbanização Rocha Brava, Alfanzina, Carvoeiro, 8400-568 Carvoeiro, Lagoa, Algarve, Portugal',
  addressLines: [
    'Urbanização Rocha Brava, Alfanzina, Carvoeiro',
    '8400-568 Carvoeiro, Lagoa',
    'Algarve, Portugal',
  ],
  lat: 37.0897,
  lng: -8.4494,
  phone: '+351 282 350 370',
  fax: '+351 282 350 371',
  bookings: '+351 282 350 375',
  website: 'https://www.rochabrava.com',
  timezone: 'Europe/Lisbon',
} as const;

export type HomePin = typeof HOME;
